
import { useEffect, useState } from "react";
import Typography from '@mui/material/Typography';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import { Divider, Box, Tab, Alert, Link, TextField} from '@mui/material';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import LinkIcon from '@mui/icons-material/Link';
import PageBreadCrumbs from "../../../components/PageBreadcrumbs";


const FactSheets = (): JSX.Element => {

  const [value, setValue] = useState('1');
  const [searchValue, setSearchValue] = useState('');
  const [debouncedSearchValue, setDebouncedSearchValue] = useState('');
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 800);
    return () => clearTimeout(timer);
  }, [searchValue]);

  const columns: GridColDef<(typeof depositoryGuides)[number]>[] = [
    {
      field: 'title',
      headerName: 'Title',
      flex: 2,  
     // minWidth: 100,
      resizable: false,
      sortable: false,
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 4,  
     // minWidth: 200,
      resizable: false,
      sortable: false,
    },
    {
      field: 'link',
      headerName: 'Link',
      flex: .25,
     // minWidth: 20,
      resizable: false,
      sortable: false,
      renderCell: (params) => (
        <Link aria-label="link to guide or fact sheet" href={params.value} target="_blank" >
            <LinkIcon/>
        </Link>
   
      )
    },
   
  ];
  
  const checklistGuides = [
    { id: 1, title: 'Candidates Who File With OCPF', description: 'A checklist of the organizing and reporting requirements for candidates who file campaign finance reports with OCPF.', link: '/PublicSearch/ViewDocument?id=3591' },
    { id: 2, title: 'House and Senate', description: 'A checklist of the organizing and reporting requirements for House and Senate candidates.', link: '/PublicSearch/ViewDocument?id=3683' },
    { id: 3, title: 'Municipal Candidates Who File With Local Election Officials', description: 'A checklist of the organizing and reporting requirements for municipal candidates who file campaign finance reports with their local election officials.', link: '/PublicSearch/ViewDocument?id=3599' },
    { id: 4, title: 'Local Party Committees', description: 'A checklist of the organizing and reporting requirements for ward, town and city political party committees.', link: '/PublicSearch/ViewDocument?id=3595' },
    { id: 5, title: 'Political Action Committees', description: 'A checklist of the organizing and reporting requirements for political action committees.', link: '/PublicSearch/ViewDocument?id=3589' },
    { id: 6, title: 'Municipal Ballot Question Committees', description: 'A checklist of the organizing and reporting requirements for ballot question committees that file with local election officials.', link: '/PublicSearch/ViewDocument?id=3594' },
    { id: 7, title: 'Statewide Ballot Question Committees', description: 'A checklist of the organizing and reporting requirements for statewide ballot question committees that file with OCPF.', link: '/PublicSearch/ViewDocument?id=3592' },
    { id: 8, title: 'Independent Expenditure PACs', description: 'A checklist of the organizing and reporting requirements for independent expenditure political action committees.', link: '/PublicSearch/ViewDocument?id=3593' },
    { id: 9, title: 'Barnstable Assembly of Delegates', description: 'A checklist of the organizing and reporting requirements for candidates for the Barnstable Assembly of Delegates.', link: '/PublicSearch/ViewDocument?id=3689' },
    { id: 10, title: 'Municipal IEPACs', description: 'A checklist of the organizing and reporting requirements for municipal independent expenditure political action committees.', link: '/PublicSearch/ViewDocument?id=3755' },
  ];

  const depositoryGuides = [
    { id: 1, title: 'Depository Candidates and State Party Committees', description: 'This guide is for candidates for the statewide offices, House, Senate, county and district offices, Governor\'s Council, mayor, city council and alderman candidates in Boston, Brockton, Cambridge, Fall River, Framingham, Haverhill, Lawrence, Lowell, Lynn, Malden, New Bedford, Newton, Quincy, Somerville, Springfield, Waltham and Worcester, as well as state political party committees.', link: '/PublicSearch/ViewDocument?id=3772' },
    { id: 2, title: 'Political Action Committee Guide', description: 'This guide is for traditional depository political action committees that file with OCPF.', link: '/PublicSearch/ViewDocument?id=3967' },
    { id: 3, title: 'One-Page Summary of the Depository Reporting System', description: 'A one-page summary of the Depository Reporting System', link: '/PublicSearch/ViewDocument?id=3389' },
    { id: 4, title: 'A Summary of the Depository Reporting System, for Legislative Candidates', description: 'A summary of the depository system, for House and Senate candidates', link: '/PublicSearch/ViewDocument?id=3683' },
    { id: 5, title: 'Savings Accounts: Depository System', description: 'This guide explains how to create and maintain a savings account in the depository system of reporting.', link: '/PublicSearch/ViewDocument?id=3961' },
  ];

  const municipalGuides = [
    { id: 6, title: 'Candidates for Municipal Office', description: 'This guide is for candidates running for local offices that have their reporting requirements with their local election officials.', link: '/PublicSearch/ViewDocument?id=3773' },
    { id: 7, title: 'Local Election Officials', description: 'This guide is designed to introduce city and town clerks and local election officials to the provisions of the campaign finance law.', link: '/PublicSearch/ViewDocument?id=3010' },
    { id: 8, title: 'Municipal Write-in Candidates', description: 'This one-paged guide assists candidates who run write-in campaigns on the local level.', link: '/PublicSearch/ViewDocument?id=3011' },
    { id: 9, title: 'Municipal Candidates Without A Committee', description: 'This one-paged guide assists candidates who run without a committee on the local level.', link: '/PublicSearch/ViewDocument?id=3775' },
    { id: 10, title: 'Municipal Candidate Booklet', description: 'A guide booklet for municipal candidates who file with their clerks and local election officials (PDF)', link: 'https://ocpf2.blob.core.windows.net/pdf/guides/municipalcandidatebook.pdf' },
    { id: 11, title: 'Municipal Ballot Question Elections', description: 'This summary guide describes how to organize and operate a Municpal Ballot Question Committee, and how to disclose its finance activity with local election officials. It also describes the prohibition on the use of public resources for election purposes.', link: '/PublicSearch/ViewDocument?id=3015' },
    { id: 12, title: 'Municipal Political Action Committees', description: 'A guide for municipal PACs that file with local election officials.', link: '/PublicSearch/ViewDocument?id=3624' },
  ];

  const otherGuides = [
    { id: 13, title: 'Independent Expenditure Political Action Committees (IE PACs)', description: 'This guide is for political action committees that receive contributions for the purpose of making independent expenditures to support or oppose a candidate or candidates.', link: '/PublicSearch/ViewDocument?id=3013' },
    { id: 14, title: 'State Ballot Question Committees', description: 'This summary guide describes how to organize a State Ballot Question Committee with OCPF, and how to disclose its financial activity.', link: '/PublicSearch/ViewDocument?id=3014' },
    { id: 21, title: 'State Ballot Question Committees', description: 'This guide is for statewide ballot question committees that support or oppose two or more questions.', link: '/PublicSearch/ViewDocument?id=4131' },
    { id: 15, title: 'Local Political Party Committees', description: 'This summary guide describes how to operate a Local Political Party Committee that is organized on the ward, town or city levels.', link: '/PublicSearch/ViewDocument?id=3776' },
    { id: 16, title: 'Public Employees, Public Resources and Political Activity', description: 'This guide is intended to answer questions concerning political and fundraising activity by government workers.', link: '/PublicSearch/ViewDocument?id=3018' },
    { id: 17, title: 'Committee Treasurers', description: 'This guide provides basic information about the role and duties of the treasurer of a political committee in Massachusetts.', link: '/PublicSearch/ViewDocument?id=3019' },
    { id: 18, title: 'Public Finance Handbook', description: 'This guide provides information about the public financing program in Massachusetts.', link: 'https://ocpf2.blob.core.windows.net/pdf/guides/2026publicfinance.pdf' },
    { id: 19, title: 'OCPF Political Party Convention Guidance', description: 'A summary of legal guidance concerning state party conventions, for parties, delegates and candidates.', link: '/PublicSearch/ViewDocument?id=3743' },
    { id: 20, title: 'Public Employee Unions and PACs', description: 'A guide for the process of collecting contributions from public employees for an affiliated union PAC.', link: '/PublicSearch/ViewDocument?id=3946' },
  ];

  const factSheetGroup1 = [
    { id: 3, title: 'How to File a Deposit Report', description: 'An illustrated guide for depository candidates and committees', link: '/PublicSearch/ViewDocument?id=3340' },
    { id: 4, title: 'How to Amend a Deposit Report', description: 'An illustrated guide for depository candidates and committees', link: '/PublicSearch/ViewDocument?id=3345' },
    { id: 5, title: 'How to File a Year-End Report in the Depository system', description: 'An illustrated guide for depository candidates and committees', link: '/PublicSearch/ViewDocument?id=3790' },
    { id: 6, title: 'How to amend a depository year-end report', description: 'An illustrated guide on how to amend a year-end report that has already been filed with OCPF.', link: '/PublicSearch/ViewDocument?id=3939' },
    { id: 8, title: 'How to dissolve a depository account with OCPF', description: 'This illustrated guide explains the process for dissolving (closing) a depository account with OCPF', link: '/PublicSearch/ViewDocument?id=3795' },
    { id: 9, title: 'How to File a Reimbursement in the Depository System', description: 'An illustrated guide for depository candidates and committees', link: '/PublicSearch/ViewDocument?id=3794' },
    { id: 10, title: 'How to Clarify an Expenditure', description: 'An illustrated guide for depository candidates and committees', link: '/PublicSearch/ViewDocument?id=3341' },
    { id: 11, title: 'How to Add/Update Occupation and Employer Information', description: 'An illustrated guide for depository candidates and committees', link: '/PublicSearch/ViewDocument?id=3275' },
    { id: 12, title: 'How to Report Credit and Debit Card Fees', description: 'An illustrated guide for depository candidates and committees', link: '/PublicSearch/ViewDocument?id=3243' },
    { id: 13, title: 'How to Account for Merchant Provider Refunds', description: 'An illustrated guide for depository candidates and committees', link: '/PublicSearch/ViewDocument?id=3507' },
    { id: 14, title: 'How to Upload Contributor Data to a Deposit Report', description: 'An illustrated guide for depository candidates and committees', link: '/PublicSearch/ViewDocument?id=3544' },
    { id: 15, title: 'How to Disclose Subvendor Expenditures', description: 'An illustrated guide for depository candidates and committees', link: '/PublicSearch/ViewDocument?id=3392' },
    { id: 16, title: 'How to Forgive a Candidate Loan', description: 'An illustrated guide for depository candidates and committees', link: '/PublicSearch/ViewDocument?id=3414' },
    { id: 17, title: 'Candidate Loan Repayment in the Depository System of Reporting', description: 'An illustrated guide for depository candidates and committees', link: '/PublicSearch/ViewDocument?id=3950' },
    { id: 35, title: 'Electronic Filing Instructions (Depository Filers)', description: 'This one-page explainer provides step-by-step instructions for Depository Committees to use OCPF reporting software.', link: '/PublicSearch/ViewDocument?id=3358' },
  ];

  const factSheetGroup2 = [
    { id: 18, title: 'How to Report Out-of-Pocket Expenditures', description: 'An illustrated guide for candidates who file with their local election officials.', link: '/PublicSearch/ViewDocument?id=3346' },
    { id: 19, title: 'How to Account for Credit and Debit Card Fees (Contributions)', description: 'An illustrated guide for candidates who file with their local election officials.', link: '/PublicSearch/ViewDocument?id=3928' },
    { id: 20, title: 'How to Use Reporter 7 to Create, Print, and File Reports', description: 'An illustrated guide for local filers who use Reporter 7 to create, print and file reports.', link: '/PublicSearch/ViewDocument?id=3350' },
    { id: 21, title: 'How to Complete and File the M102 Campaign Finance Form', description: 'An illustrated guide for candidates who file with their local election officials.', link: '/PublicSearch/ViewDocument?id=3353' },
    { id: 28, title: 'Municipal Ballot Question Committees', description: 'Illustrated and detailed guide for completing and filing the M102 campaign finance form.', link: '/PublicSearch/ViewDocument?id=4020' },
    { id: 37, title: 'Common Errors Made When Completing Campaign Finance Reports', description: 'This guide helps committees to avoid common errors made when completing campaign finance reports.', link: '/PublicSearch/ViewDocument?id=3357' },
  ];

  const factSheetGroup3 = [
    { id: 7, title: 'Traditional PACs that make Independent Expenditures', description: 'An illustrated guide for depository candidates and committees', link: '/PublicSearch/ViewDocument?id=3528' },
    { id: 22, title: 'Traditional municipal PACs that make independent expenditure', description: 'An illustrated guide for Traditional municipal PACs that make independent expenditure.', link: '/PublicSearch/ViewDocument?id=3354' },
    { id: 24, title: 'Independent Spending', description: 'This illustrated guide demonstrates how to register to file reports for independent expenditures (18A), electioneering communications and independent ballot question spending.', link: '/PublicSearch/ViewDocument?id=3388' },
    { id: 34, title: 'Traditional political action committees that make independent expenditures', description: 'This guide explains the steps a state-level PAC must take if it makes independent expenditures to support or oppose candidates who file with OCPF.', link: 'https://ocpf2.blob.core.windows.net/pdf/guides/traditionalpacieguide.pdf' },
  ];

  const factSheetGroup4 = [
    { id: 1, title: "OCPF's Top 10 Campaign Finance Rules", description: "You're Running for Office: OCPF's Top 10 campaign finance rules, in printable form.", link: "https://ocpf2.blob.core.windows.net/pdf/guides/yourerunning.pdf" },
    { id: 2, title: 'Annual Campaign Contribution Limits', description: 'Click here to view a chart of the contribution limits to candidates and political committees in Massachusetts.', link: '/Legal/ContributionLimits' },
    { id: 23, title: 'Paid for By Guide', description: 'An illustrated guide that provides examples of disclaimers on campaign materials.', link: '/PublicSearch/ViewDocument?id=3355' },
    { id: 25, title: 'How to file a segregated fund report', description: 'How to e-file a report for a legal, inaugural and recount fund, for candidates who file with OCPF.', link: '/PublicSearch/ViewDocument?id=3998' },
    { id: 29, title: 'Campaign Finance Law Changes: A Timeline', description: 'Guide: Timeline of campaign finance law revisions.', link: '/PublicSearch/ViewDocument?id=3698' },
    { id: 30, title: 'How to dissolve a committee', description: 'Committees that have no cash balance, assets or outstanding liabilities and wish to dissolve may do so, as long as the candidate represented by the committee does not still hold elected office.', link: '/PublicSearch/ViewDocument?id=2563' },
    { id: 31, title: "Changing the purpose of a candidate's committee", description: "Guide: Changing the purpose of a candidate's committee (when a candidate decides to run for another office)", link: '/PublicSearch/ViewDocument?id=3003' },
    { id: 32, title: 'Public Employee, Public Buildings & Public Property Booklet', description: 'This is a four-page summary describing the implications of the campaign finance law for public employees and public buildings, and the use of public resources for political purposes.', link: 'https://ocpf2.blob.core.windows.net/pdf/guides/employeebuildingspropertyguide.pdf' },
    { id: 33, title: 'How to Report Late Contributions', description: 'This guide describes how and when to file Late Contribution Reports.', link: '/PublicSearch/ViewDocument?id=3005' },
    { id: 36, title: 'The Campaign Finance Law and Businesses', description: 'This one-page explainer provides guidance on the impact of the campaign finance law on businesses.', link: '/PublicSearch/ViewDocument?id=3777' },
    { id: 39, title: "An Overview of the Massachusetts Public Finance System", description: "Statewide candidates should review this guide, whether they plan on participating in the public financing system or not. The public financing system provides matching contributions to qualified candidates.", link: 'https://ocpf2.blob.core.windows.net/pdf/guides/public_financing_3.pdf' },
    { id: 40, title: "Application of Spending Limit Declarations", description: "This guide describes the process that statewide candidates follow concerning spending limit statements.", link: 'https://ocpf2.blob.core.windows.net/pdf/guides/public_financing_1.pdf' },
    { id: 41, title: "Statewide Candidates Expenditure Statements", description: "This guide describes the process that statewide candidates follow concerning expenditure statements.", link: 'https://ocpf2.blob.core.windows.net/pdf/guides/public_financing_2.pdf' },
  ];

  const factSheetGroup5 = [
    { id: 26, title: 'Local Party Committee: How to e-file report using Reporter 7', description: 'An illustrated guide for local party committees on how to use Reporter 7 to e-file reports', link: '/PublicSearch/ViewDocument?id=4001' },
    { id: 27, title: 'How to report credit/debit card merchant provider fees, for local party committees', description: 'An illustrated guide for disclosing merchant provide fees for local party committees.', link: '/PublicSearch/ViewDocument?id=4016' },
  ];

  const filterRows = (rows: any[]) => {
    const query = debouncedSearchValue.trim().toLowerCase();
    if (!query) return rows;
    return rows.filter(row =>
      row.title.toLowerCase().includes(query) ||
      row.description.toLowerCase().includes(query)
    );
  };

  return (
    <Main>
      <Container>
        <PageBreadCrumbs></PageBreadCrumbs>
        <Typography
            component="h1"
            variant="h4"
            align={'left'}
            data-aos={'fade-up'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            gutterBottom
            marginBottom={2}
            >
            OCPF Guides & Fact Sheets
        </Typography>
        <Divider/>
        <Box p={2} marginBottom={2} >
            <Typography> OCPF issues various publications to help candidates, committees, public employees and others understand the campaign finance law. Every publication is available at no cost and we will provide them via email, fax or mail upon request.</Typography>
        </Box>

        <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList  onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Campaign Finance Guides" value="1" />
            <Tab label="Campaign Finance Fact Sheets" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
        <Box sx={{ height: '100%', width: '100%' }}>
        <Alert severity="info"><b>Campaign finance guides</b> explain the disclosure requirements and filing processes for candidates and committees.</Alert>

        <Box sx={{ padding: '10px', mb: 2, mt: 1 }}>
          <TextField
            label="Search Guides"
            variant="outlined"
            size="small"
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
          />
        </Box>

      <Typography variant="subtitle1" display={'flex'} justifyContent={'center'} fontWeight={550}>Section 1: Candidate and Committee Checklists</Typography>
      <DataGrid
        rows={filterRows(checklistGuides)}
        columns={columns}
        disableColumnMenu
        getRowHeight={() => 'auto'}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 50 }
          },
        }}
        pageSizeOptions={[50]}
        disableRowSelectionOnClick
        hideFooter
        sx={{
          marginTop: 2,
          marginBottom: 2,
          '& .MuiDataGrid-cell': {
            alignItems: 'center',
            display: 'flex',
            paddingTop: '3px',
            paddingBottom: '3px',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }
        }}
      />

      <Typography variant="subtitle1" display={'flex'} justifyContent={'center'} fontWeight={550}>Section 2: Depository System (state level)</Typography>
      <DataGrid
        rows={filterRows(depositoryGuides)}
        columns={columns}
        disableColumnMenu
        getRowHeight={() => 'auto'}
        initialState={{
          pagination: { 
            paginationModel: { pageSize: 50 } 
          },
        }}
        pageSizeOptions={[50]}
        disableRowSelectionOnClick
        hideFooter
        sx={{
          marginTop: 2,  
          marginBottom: 2,
          '& .MuiDataGrid-cell': {
            alignItems: 'center',
            display: 'flex',
            paddingTop: '3px',
            paddingBottom: '3px',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }
        }}
      />

      <Typography variant="subtitle1" display={'flex'} justifyContent={'center'} fontWeight={550}>Section 3: Municipal Filers Guides</Typography>
      <DataGrid
        rows={filterRows(municipalGuides)}
        columns={columns}
        disableColumnMenu
        getRowHeight={() => 'auto'}
        initialState={{
          pagination: { 
            paginationModel: { pageSize: 50 } 
          },
        }}
        pageSizeOptions={[50]}
        disableRowSelectionOnClick
        hideFooter
        sx={{
          marginTop: 2,
          marginBottom: 2,  
          '& .MuiDataGrid-cell': {
            alignItems: 'center',
            display: 'flex',
            paddingTop: '3px',
            paddingBottom: '3px',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }
        }}
      />

      <Typography variant="subtitle1" display={'flex'} justifyContent={'center'} fontWeight={550}>Section 4: Other Guides</Typography>
      <DataGrid
        rows={filterRows(otherGuides)}
        columns={columns}
        disableColumnMenu
        getRowHeight={() => 'auto'}
        initialState={{
          pagination: { 
            paginationModel: { pageSize: 50 } 
          },
        }}
        pageSizeOptions={[50]}
        disableRowSelectionOnClick
        hideFooter
        sx={{
          marginTop: 2,  
          '& .MuiDataGrid-cell': {
            alignItems: 'center',
            display: 'flex',
            paddingTop: '3px',
            paddingBottom: '3px',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }
        }}
      />
    </Box>
        </TabPanel>
    <TabPanel value="2">
        <Box sx={{ height: '100%', width: '100%' }}>
        <Alert severity="info">
          <b>Campaign finance fact sheets</b> are brief overviews, explainers or charts that contain basic information about aspects of the campaign finance law.
        </Alert>

        <Box sx={{ padding: '10px', mb: 2, mt: 1 }}>
          <TextField
            label="Search Fact Sheets"
            variant="outlined"
            size="small"
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
          />
        </Box>

        <Typography variant="subtitle1" display={'flex'} justifyContent={'center'} fontWeight={550}>Section 1: Depository Candidates and Political Action Committees</Typography>
        <DataGrid
          rows={filterRows(factSheetGroup1)}
          columns={columns}
          hideFooter
          disableColumnMenu
          getRowHeight={() => 'auto'}
          initialState={{ pagination: { paginationModel: { pageSize: factSheetGroup1.length } } }}
          pageSizeOptions={[50]}
          disableRowSelectionOnClick
          sx={{ marginTop: 2, marginBottom: 2, '& .MuiDataGrid-cell': { alignItems: 'center', display: 'flex', paddingTop: '3px', paddingBottom: '3px', whiteSpace: 'normal', wordWrap: 'break-word' } }}
        />

        <Typography variant="subtitle1" display={'flex'} justifyContent={'center'} fontWeight={550}>Section 2: Local (Municipal) Filers</Typography>
        <DataGrid
          rows={filterRows(factSheetGroup2)}
          columns={columns}
          hideFooter
          disableColumnMenu
          getRowHeight={() => 'auto'}
          initialState={{ pagination: { paginationModel: { pageSize: factSheetGroup2.length } } }}
          pageSizeOptions={[50]}
          disableRowSelectionOnClick
          sx={{ marginTop: 2, marginBottom: 2, '& .MuiDataGrid-cell': { alignItems: 'center', display: 'flex', paddingTop: '3px', paddingBottom: '3px', whiteSpace: 'normal', wordWrap: 'break-word' } }}
        />

        <Typography variant="subtitle1" display={'flex'} justifyContent={'center'} fontWeight={550}>Section 3 Independent Spending: IEPACs, Electioneering Communications, <br />18A (independent 
expenditures) , and M22s (independent ballot question expenditures)</Typography>
        <DataGrid
          rows={filterRows(factSheetGroup3)}
          columns={columns}
          hideFooter
          disableColumnMenu
          getRowHeight={() => 'auto'}
          initialState={{ pagination: { paginationModel: { pageSize: factSheetGroup3.length } } }}
          pageSizeOptions={[50]}
          disableRowSelectionOnClick
          sx={{ marginTop: 2, marginBottom: 2, '& .MuiDataGrid-cell': { alignItems: 'center', display: 'flex', paddingTop: '3px', paddingBottom: '3px', whiteSpace: 'normal', wordWrap: 'break-word' } }}
        />

        <Typography variant="subtitle1" display={'flex'} justifyContent={'center'} fontWeight={550}>Section 4: General Guidance</Typography>
        <DataGrid
          rows={filterRows(factSheetGroup4)}
          columns={columns}
          hideFooter
          disableColumnMenu
          getRowHeight={() => 'auto'}
          initialState={{ pagination: { paginationModel: { pageSize: factSheetGroup4.length } } }}
          pageSizeOptions={[50]}
          disableRowSelectionOnClick
          sx={{ marginTop: 2, marginBottom: 2, '& .MuiDataGrid-cell': { alignItems: 'center', display: 'flex', paddingTop: '3px', paddingBottom: '3px', whiteSpace: 'normal', wordWrap: 'break-word' } }}
        />

        <Typography variant="subtitle1" display={'flex'} justifyContent={'center'} fontWeight={550}>Section 5: Local Party Committees</Typography>
        <DataGrid
          rows={filterRows(factSheetGroup5)}
          columns={columns}
          hideFooter
          disableColumnMenu
          getRowHeight={() => 'auto'}
          initialState={{ pagination: { paginationModel: { pageSize: factSheetGroup5.length } } }}
          pageSizeOptions={[50]}
          disableRowSelectionOnClick
          sx={{ marginTop: 2, '& .MuiDataGrid-cell': { alignItems: 'center', display: 'flex', paddingTop: '3px', paddingBottom: '3px', whiteSpace: 'normal', wordWrap: 'break-word' } }}
        />
    </Box>
    </TabPanel>
    </TabContext>
        
      </Container>
    </Main>
  );
};

export default FactSheets;